import { forwardRef, useState } from 'react';
import { Hero } from '../components';
import {
  HomeContainer,
  PageControl,
  PageNav,
  PageNavBrand,
  PageNavHolder,
  PageNavItem,
} from '../components/styled';
import jmBold from '../assets/jm-bold.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faClose } from '@fortawesome/free-solid-svg-icons';

export const Home = forwardRef(({ height, shouldNavBarStick, onLinkClicked, currentPage }, ref) => {
  const [showNav, setShowNav] = useState(false);
  const handleLinkClick = e => {
    onLinkClicked(e.currentTarget.dataset.scrollTarget);
  };
  const navBarToggle = () => {
    setShowNav(prev => !prev);
  };
  return (
    <HomeContainer ref={ref} height={height} id="home">
      <Hero />
      {!showNav && (
        <PageControl onClick={navBarToggle}>
          <FontAwesomeIcon icon={faBars} />
        </PageControl>
      )}
      <PageNavHolder
        width={shouldNavBarStick ? '100%' : '750px'}
        shouldStick={shouldNavBarStick}
        stickHeight={height + 65}
        style={{ display: showNav && 'flex' }}
      >
        <PageNav>
          <PageNavBrand
            className={currentPage === 'home' && 'active'}
            onClick={handleLinkClick}
            data-scroll-target="home"
          >
            <img src={jmBold} alt="" />
          </PageNavBrand>
          <PageControl onClick={navBarToggle}>
            <FontAwesomeIcon icon={faClose} />
          </PageControl>
          <PageNavItem
            className={currentPage === 'about' && 'active'}
            onClick={handleLinkClick}
            data-scroll-target="about"
          >
            About
          </PageNavItem>
          <PageNavItem
            className={currentPage === 'portfolio' && 'active'}
            onClick={handleLinkClick}
            data-scroll-target="portfolio"
          >
            Body Of Work
          </PageNavItem>
          <PageNavItem
            className={currentPage === 'contact' && 'active'}
            onClick={handleLinkClick}
            data-scroll-target="contact"
          >
            Contact Me
          </PageNavItem>
          {/* <PageNavItem className={currentPage === 'blog' && 'active'} scroll-target="blog">
            <a href="/blogs.html">Blog & Articles</a>
          </PageNavItem> */}
        </PageNav>
      </PageNavHolder>
    </HomeContainer>
  );
});
